import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styles from './navBar.module.scss';

interface SellDropdownProps {
    className?: string;
}

const SellDropdownBrand = ({ className }: SellDropdownProps) => {
    const navigate = useNavigate();

    const handleOptionClick = (path: string) => {
        navigate(path);
    };

    return (
        <div className={`${styles.sellDropdownBrand} ${className}`}>
            <button className={styles.sellButton} onClick={() => handleOptionClick('/sell/new-car-brand')}>
                <span>Publica tu 0km</span>
            </button>
        </div>
    );
};

export default SellDropdownBrand;
